// ─────────────────────────────────────────────
//  App Configuration
//  Runtime values come from window._env_ which
//  is written by docker-entrypoint.sh at startup.
//  Hardcoded values below are fallbacks for
//  local development only (npm start).
// ─────────────────────────────────────────────

const env = window._env_ || {};

// ── WebSocket / API ──────────────────────────
const WS_BASE_HOST = env.WS_BASE_HOST || '';
export const ORG_CODE = env.ORG_CODE || null;
export const WS_URL = ORG_CODE && WS_BASE_HOST
  ? `wss://${WS_BASE_HOST}/wss-chat-prod/api/v1/arya/arya_socket/chatbot-ws-stream?org_code=${ORG_CODE}`
  : null;

// ── Form submission ──────────────────────────
export const buildFormSubmitUrl = (ownerId) =>
  WS_BASE_HOST && ownerId
    ? `https://${WS_BASE_HOST}/wss-chat-prod/api/v1/arya/chat/save_input_form_data?org_code=${ownerId}`
    : null;

// reCAPTCHA site keys are public by design (embedded in every page's HTML) — safe to hardcode.
export const RECAPTCHA_SITE_KEY = '6LclnXktAAAAAGK1VPa1F3CFHu-P6QtBWW07ZUuf';

// ── Logos ────────────────────────────────────
export const LOGOS = {
  logo: '/logos/logo.png',
};

// ── UI copy ──────────────────────────────────
export const INPUT_PLACEHOLDER = 'Message arya…';
export const DISCLAIMER =
  env.DISCLAIMER || 'arya may produce errors — always verify with current clinical guidelines';
export const WELCOME_HEADING =
  env.WELCOME_HEADING || 'Welcome! How can I help you today?';

// Pipe-separated in env: "Question one|Question two|Question three"
export const SUGGESTIONS = env.SUGGESTIONS
  ? env.SUGGESTIONS.split('|').map((s) => s.trim()).filter(Boolean)
  : [];

// Set to TRUE in env to show suggestion chips (welcome + follow-ups); any other value hides them
export const TOGGLE_SUGGESTION =
  (env.TOGGLE_SUGGESTION || 'TRUE').toUpperCase() === 'TRUE';
